import { FC, Suspense, useEffect } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import GemImage from 'src/components/GemImage';
import { MobileModalType, ModalHeader, ModalHeaderTitle } from 'src/components/ModalLayout';
import { RootStyle } from 'src/components/Payments/style';
import useGemAmount from 'src/hooks/useGemAmount';
import useLogin from 'src/hooks/useLogin';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { numComma } from 'src/utils/common';
import { pushEvent } from 'src/utils/event-gateway';
import ShopContent from './Content';
import ShopLoading from './Loading';
const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const MyGems = styled.div`
  display: flex;
  color: ${({
  theme
}) => theme.color.content12};
  font-size: 16px;
  align-items: center;
  gap: 5px;
`;
const ImgGemSquare = styled(GemImage)`
  width: 20px;
  height: 20px;
`;
const ShopComponent: FC = () => {
  const {
    t
  } = useTranslation();
  const gemAmount = useGemAmount();
  const {
    isLogin
  } = useLogin();
  useEffect(() => {
    if (isLogin) {
      pushEvent({
        eventType: EVENT_TYPE.PURCHASE,
        eventName: EVENT_NAME.SHOP_OPEN
      });
    }
  }, [isLogin]);
  if (!isLogin) {
    return <RootStyle />;
  }
  return <>
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
        <TitleWrapper data-sentry-element="TitleWrapper" data-sentry-source-file="index.tsx">
          <ModalHeaderTitle mobileType={MobileModalType.SCREEN_MODAL} data-sentry-element="ModalHeaderTitle" data-sentry-source-file="index.tsx">
            {t('shop_title')}
          </ModalHeaderTitle>
          <MyGems data-sentry-element="MyGems" data-sentry-source-file="index.tsx">
            <ImgGemSquare data-sentry-element="ImgGemSquare" data-sentry-source-file="index.tsx" />
            {numComma(gemAmount || 0)}
          </MyGems>
        </TitleWrapper>
      </ModalHeader>
      <Suspense fallback={<ShopLoading />} data-sentry-element="Suspense" data-sentry-source-file="index.tsx">
        <ShopContent data-sentry-element="ShopContent" data-sentry-source-file="index.tsx" />
      </Suspense>
    </>;
};
export default ShopComponent;